import React, { useEffect, useState } from "react";
import { LottieRenderer } from "./LottieRenderer";
import { lottieLoaderJson } from "./lottieLoaderjson";
export const LottieLoader = () => {
    const [lottieModule, setLottieModule] = useState(null);
    useEffect(() => {
        if (typeof window !== "undefined") {
            // Dynamically load LottieReact and animation data
            import("lottie-react")
                .then((module) => setLottieModule(module))
                .catch((err) => console.error("Error loading Lottie:", err));
        }
    }, []);
    if (!lottieModule || !lottieLoaderJson) {
        // Gracefully handle loading state or SSR
        return null;
    }
    // Pass the dynamically loaded useLottie and JSON data to the child component
    const { useLottie } = lottieModule;
    return React.createElement(LottieRenderer, { useLottie: useLottie, animationData: lottieLoaderJson });
};
export default LottieLoader;
//# sourceMappingURL=LottieLoader.js.map